var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiamondWhite = function SvgDiamondWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 248 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.269 0c0 10.652-8.2 19.256-18.269 19.256v.488c10.105 0 18.269 8.642 18.269 19.256h.462c0-10.651 8.2-19.256 18.269-19.256v-.488c-10.105 0-18.269-8.642-18.269-19.256h-.462Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 19.5H0h248",
    stroke: "#fff"
  })));
};

export { SvgDiamondWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQ4IiBoZWlnaHQ9IjM5IiB2aWV3Qm94PSIwIDAgMjQ4IDM5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyNC4yNjkgMEMxMjQuMjY5IDEwLjY1MTUgMTE2LjA2OSAxOS4yNTYzIDEwNiAxOS4yNTYzVjE5Ljc0MzdDMTE2LjEwNSAxOS43NDM3IDEyNC4yNjkgMjguMzg2MyAxMjQuMjY5IDM5SDEyNC43MzFDMTI0LjczMSAyOC4zNDg1IDEzMi45MzEgMTkuNzQzNyAxNDMgMTkuNzQzN1YxOS4yNTYzQzEzMi44OTUgMTkuMjU2MyAxMjQuNzMxIDEwLjYxMzcgMTI0LjczMSAwSDEyNC4yNjlaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTA2IDE5LjVIMEgyNDgiIHN0cm9rZT0id2hpdGUiLz4KPC9zdmc+Cg==";